import { render, staticRenderFns } from "./PickupGroups.vue?vue&type=template&id=86151456&"
import script from "./PickupGroups.vue?vue&type=script&lang=js&"
export * from "./PickupGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports